module.exports = __webpack_public_path__ + "img/director-tiao-icon4.96d47593.png";